import React from 'react'

export default function ComingSoon() {
    return (
        <div className="coming-soon-page">
            <div>十六茶 PK「可爾必思」</div>
            <div>中秋烤宴集點選邊戰活動</div>
            <div>將於8/15開始！</div>
        </div>
    )
}